import { useCallback, useEffect, useRef, useState } from 'react';

interface UseOutsideClickResult {
  ref: React.RefObject<HTMLInputElement | HTMLDivElement>;
  isComponentVisible: boolean;
  setIsComponentVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function useOutsideClick(initialState: boolean): UseOutsideClickResult {
  const ref = useRef(null);
  const [isComponentVisible, setIsComponentVisible] = useState(initialState);

  const handleOutsideClick = useCallback(
    (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsComponentVisible(false);
      }
    },
    [ref],
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [ref, isComponentVisible, handleOutsideClick]);

  return { ref, isComponentVisible, setIsComponentVisible };
}
